module.exports = "/images/water park.svg?e2122080ae2faf1c06be1875f7b1380d";